import { render, staticRenderFns } from "./authZyb.vue?vue&type=template&id=0fb6e2cd&scoped=true&"
import script from "./authZyb.vue?vue&type=script&lang=js&"
export * from "./authZyb.vue?vue&type=script&lang=js&"
import style0 from "./authZyb.vue?vue&type=style&index=0&id=0fb6e2cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb6e2cd",
  null
  
)

export default component.exports